// src/components/PublicLayout.jsx

import { Box } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";

import PublicFooter from "./PublicFooter";
import UniversalHeader from "./UniversalHeader";
import PatAssistant from "./Pat/PatAssistant";

const MotionBox = motion(Box);

export default function PublicLayout({ children }) {
  const location = useLocation();

  return (
    <Box
      minH="100vh"
      bg="gray.50"
      display="flex"
      flexDirection="column"
    >
      {/* UNIVERSAL HEADER */}
      <UniversalHeader title="postcode.coupons" />

      {/* PAGE CONTENT */}
      <MotionBox
        as="main"
        key={location.pathname}
        flex="1"
        width="100%"
        initial={{
          opacity: 0,
          y: 8,
        }}
        animate={{
          opacity: 1,
          y: 0,
        }}
        transition={{
          duration: 0.25,
        }}
      >
        {children}
      </MotionBox>

      {/* ASK PAT */}
      <PatAssistant />

      {/* FOOTER */}
      <PublicFooter />
    </Box>
  );
}